var data = { header:{ text:"#### This selection is not supported for {{it.country}} at this time:",
    postProcessingAction:"processRnaUnsupportedCountryValidationError" },
  body:{ text:"{{it.invalidTestNames}}<br>\n\nThis selection could not be added to your cart. Please review the Alternate Tests section for additional options to consider.",
    postProcessingAction:"processRnaUnsupportedCountryValidationError" },
  buttons:[ { text:"Edit selected",
      isPrimary:true,
      action:"gotoCartPage" } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=rna_unsupported_country_error.esm.js.map
